'use strict';
import angular from 'angular';
import './scripts/integrations.ctrls';
import './scripts/integrations.directives';
import './scripts/integrations.services';

import integrationsHtmlUrl from './views/integrations.html';
import mappingsHtmlUrl from './views/mappings.html';
import configureImportHtmlUrl from './views/configureImport.html';
import addFileIntegrationHtmlUrl from './views/addFileIntegration.html';
import addSalesForceIntegrationHtmlUrl from './views/addSalesforceIntegration.html';
import webhookFormHtmlUrl from './views/webhookForm.html';
import integrationActivityLogHtmlUrl from './views/integrationActivityLog.html';
import activityLogResultViewHtmlUrl from './views/activityLogResultView.html';

angular.module('integrations', [
    'integrations.ctrls',
    'integrations.directives',
    'integrations.services'
])

    .config(['$stateProvider', function($stateProvider) {
        $stateProvider
            .state('integrations', {
                parent: 'layout',
                url: '/admin/integrations',
                templateUrl: integrationsHtmlUrl,
                controller: 'IntegrationsController'
            })
            .state('integrations.mappings', {
                parent: 'layout',
                url: '/admin/integrations/:id/mappings/:type',
                templateUrl: mappingsHtmlUrl,
                controller: 'IntegrationsMappingsController',
                params: {
                    'isSalesForce': null
                }
            })
            .state('integrations.configure', {
                parent: 'layout',
                url: '/admin/integrations/:id/configure/:type',
                templateUrl: configureImportHtmlUrl,
                controller: 'ConfigureImportController',
                params: {
                    'isSalesForce': null
                }
            })
            .state('integrations.fileIntegration', {
                parent: 'layout',
                url: '/admin/integrations/addFileIntegration',
                templateUrl: addFileIntegrationHtmlUrl,
                controller: 'FileIntegrationController',
                controllerAs: 'vm'
            })
            .state('integrations.updateFileIntegration', {
                parent: 'layout',
                url: '/admin/integrations/:id/updateFileIntegration/:serviceConnectionId',
                templateUrl: addFileIntegrationHtmlUrl,
                controller: 'FileIntegrationController',
                controllerAs: 'vm'
            })
            .state('integrations.salesforceIntegration', {
                parent: 'layout',
                url: '/admin/integrations/addSalesforceIntegration',
                templateUrl: addSalesForceIntegrationHtmlUrl,
                controller: 'SalesforceIntegrationController',
                controllerAs: 'vm'
            })
            .state('integrations.updateSalesforceIntegration', {
                parent: 'layout',
                url: '/admin/integrations/:id/updateSalesforceIntegration/:serviceConnectionId',
                templateUrl: addSalesForceIntegrationHtmlUrl,
                controller: 'SalesforceIntegrationController',
                controllerAs: 'vm'
            })
            .state('integrations.webhook', {
                parent: 'layout',
                url: '/admin/integrations/:id/webhook/:webhookType',
                templateUrl: webhookFormHtmlUrl,
                controller: 'WebhookController',
                controllerAs: 'vm',
                params: {
                    'integration': null
                }
            })
            .state('integrations.activityLog', {
                parent: 'layout',
                url: '/admin/integrations/:id/activityLog/:type',
                templateUrl: integrationActivityLogHtmlUrl,
                controller: 'IntegrationActivityLogController'
            })
            .state('integrations.activityResultView', {
                parent: 'layout',
                url: '/admin/integrations/:id/activityLogResult/:type/:batch_log_id/:batch_id',
                templateUrl: activityLogResultViewHtmlUrl,
                controller: 'ActivityLogResultViewController',
            })
    }]);